<template>
<div style="height:100%;overflow-y:auto;background-color:#eee">
<v-toolbar absolute flat dark dense class="primary">
    <v-btn @click.native="$router.push('/home')" icon>
        <v-icon>chevron_left</v-icon>
    </v-btn>        
    <v-toolbar-title>Components</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn icon>
        <v-icon>search</v-icon>
    </v-btn>
    <v-btn icon>
        <v-icon>more_vert</v-icon>
    </v-btn>
</v-toolbar>  



  <v-navigation-drawer absolute :mobile-break-point="900" :width="240" style="top:48px;">
    <v-toolbar flat>
      <v-list>
        <v-list-item>
          <v-list-item-title class="title">
            Application
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-toolbar>

    <v-divider></v-divider>

    <v-list dense class="pt-0">
      <v-list-item>
        <v-list-item-action>
          <v-icon>security</v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>Security</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-action>
          <v-icon>account_circle</v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>People</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>

  <v-navigation-drawer right absolute :mobile-break-point="1200" :width="350" style="top:48px;background-color:#ddd">
      <div style="padding:10px">
    <span style="color:#bbb;" v-for="n in 100">Lorem ipsum, dolor sit amet consectetur adipisicing elit. Expedita quam nobis fugiat iusto illum officia facilis dolor debitis assumenda, sit iure odio laboriosam autem obcaecati minima repudiandae, quidem cupiditate aliquam! </span>

      </div>
  </v-navigation-drawer>



<div class="main-page">









        <div style="width:100%;background-color:#eee;padding:0 5px;">
            <div style="margin: 0 auto;max-width: 600px;">

            <SectionLayout :section-properties="{
                title: 'Personal Details',
            }">
                <ElementLayout :element-properties="{
                    title: 'First Name',
                    complete: true,
                    icon: 'account_circle',
                }">
                    <v-text-field
                        label="First Name"
                        xxxbox hide-details
                    ></v-text-field>
                    <v-btn slot="right" small outline color="grey" class="right-button">Lookup</v-btn>
                </ElementLayout>
            
                <ElementLayout :element-properties="{
                    title: 'Last Name',
                    complete: false
                }">
                     <LayoutReadOnly label="Middle Name" value="Jenson" />

                </ElementLayout>
                <ElementLayout :element-properties="{
                    complete: true
                }">
                    <LayoutReadOnly label="Preferred Name (or Nickname)" value="PJ" />

                </ElementLayout>
                <ElementLayout :element-properties="{
                    title: 'Last Name',
                    complete: false
                }">
                    <LayoutReadOnly label="Spouses Name" value="Maria" />

                </ElementLayout>
                <ElementLayout :element-properties="{
                    title: 'Last Name',
                    complete: false
                }">
                    <v-text-field
                        label="Last Name"
                        xxxbox hide-details
                    ></v-text-field>
                </ElementLayout>
                <ElementLayout :element-properties="{
                    title: 'Favourite Colour',
                    complete: false
                }">
                    <v-select
                        label="Favourite Colour"
                        hide-details
                        :items="['Red', 'Orange', 'Yellow', 'Green']"
                    ></v-select>
                </ElementLayout>
            </SectionLayout>
            <SectionLayout :section-properties="{
                title: 'Contact Preferences',
            }">
                Section 2
            </SectionLayout>
            </div>
        </div>


        <div style="background-color:white;" class="elevation-2 pa-3 mb-2 mt-5">

        Contact Autocomplete
        <ContactAutocomplete v-model="selectedContacts" :items="contacts" single-line />
        <br/>
        DateTime
        <DateTime v-model="dateAndTime" label="Appointment Time" />
        <br/>
        Dynamic Control
        <DynamicControl v-model="specialValue" :field="specialField" />
        </div>
  
    </div>

</div>
</template>

<script>
    import NumberHelpers from '../helpers/NumberHelpers'
    import ContactAutocomplete from '../ui-elements/ContactAutocomplete'
    import DateTime from '../ui-elements/DateTime'
    import DynamicControl from '../ui-elements/DynamicControl'
    import SectionLayout from '../screens/SectionLayout'
    import ElementLayout from '../screens/ElementLayout'
    import LayoutReadOnly from '../ui-elements/LayoutReadOnly'

    export default {
        name: 'Components',
        data() {
            return {
                selectedContacts: [],
                contacts: [
                    {key: 1, firstName: 'Matt', lastName: 'Ireland', email: 'matt@ireland.mx', mobile: '0413999951', image: 'https://placeimg.com/40/40/people/45'},
                    {key: 2, firstName: 'Linda', lastName: 'Ireland', email: 'linda@ireland.mx', mobile: '0414012714', image: 'https://placeimg.com/40/40/people/46'},
                    {key: 3, firstName: 'Peter', lastName: 'Solomon', email: 'pete.solomon@mortgagechoice.com.au', mobile: '0413999953', image: 'https://placeimg.com/40/40/people/47'},
                ],

                dateAndTime: '2013-02-27 10:30pm',
                specialValue: 'Hello',
                specialField: {
                    name: 'MyField',
                    type: 'tf',
                }

            }
        },
        components: {
            ContactAutocomplete,
            DateTime,
            DynamicControl,
            SectionLayout,
            ElementLayout,
            LayoutReadOnly,
        },
        computed:{

        },
        methods: {

        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-page {
    transition: margin .3s ease-in-out;
    padding-top:48px;
}
@media (min-width: 900px) {
    .main-page {
        margin-left:250px;
    }
}
@media (min-width: 1200px) {
    .main-page {
        margin-right:360px;
    }
}


</style>


// WEBPACK FOOTER //
// Components.vue?07b16e08